import { useNavigate, useParams } from 'react-router-dom';

import { Button, Typography } from 'antd';

import { IContent } from '@/interfaces/lesson';

const Text = (props: IContent | any) => {
  const { hash, id } = useParams();
  const navigate = useNavigate();
  const handleClick = () => {
    navigate(`/curso/${hash}/aula/${id}/${props.id}`);
  };
  const examContent = (
    <div className='examContent'>
      <Typography.Text>Para ter acesso a prova clique no botão abaixo para entrar no ambiente</Typography.Text>
      <Button type='primary' onClick={handleClick}>
        Entrar no Ambiente de Prova
      </Button>
    </div>
  );

  return <>{props.embed.error ? null : examContent}</>;
};

export default Text;
